import { render, staticRenderFns } from "./OrderCheckoutVehicleInclusion.vue?vue&type=template&id=1897f4ae"
import script from "./OrderCheckoutVehicleInclusion.vue?vue&type=script&lang=js"
export * from "./OrderCheckoutVehicleInclusion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports